<template>
  <div class="modal show fade modal-dark text-left" style="display: block;" v-if="show">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" style="text-transform:capitalize;">Terminal Configuration</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="">
            <div class="row">
              <div v-for="(field, index) in list" :key="index" class="col-md-6">
                <div class="form-group">
                  <!-- Checkbox Input -->
                  <div class="custom-control custom-switch mb-1">
                    <input
                        type="checkbox"
                        class="custom-control-input"
                        :id="field.name"
                        v-model="list[index].value"
                    />
                    <label class="custom-control-label" :for="field.name">{{ field.title }}</label>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <Button class="btn btn-primary mr-1 mt-2 btn-sm" @click="sendCall" :loading="loading">Update</Button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="show" class="modal-backdrop fade show"></div>
</template>

<script>

import Button from "@/components/common/Button.vue";

export default {
  components: {Button},
  props: ['show','posStaff'],
  data() {
    return {
      list: [],
      loading:false,
      terminalSettingList:[]
      // showModal: false,
    }
  },
  mounted() {
    this.getTerminalSettingsList()
  },
  methods: {
    sendCall() {

      //extracting ids to send with the request
      const checked = this.list
          .filter(item => item.value)
          .map(item => item.name);

      let data = {
        posStaffId: this.posStaff?.pivot?.id,
        settings: JSON.stringify(checked)
      }
      this.loading = true
      this.makeRequest('post', 'v1/manage-pos-devices', data).then(callResponse => {

        this.loading = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if(code == 200){
            this.$emit('hide')
            this.$router.push({ name: 'pos-devices' })
          }
        }

      });

    },
    async getTerminalSettingsList(){
      let data = {
        posDeviceId: this.decryptData(this.$route.params.id),
        settingDetails:1
      }
      this.loading = true
      this.makeRequest('post', 'v1/get-pos-devices', data,{}, false).then(callResponse => {

        this.loading = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if(code == 200){
            this.terminalSettingList = callResponse.response.data.data
          }
        }

      });
    }
  },
  watch: {
    async show(val) {
      if(!val){
        this.list = []
        return
      }

      // let channelData = this.$store.getters.getPosChannelData?.channels
      let list = []
      // if(channelData && channelData.length > 0){
      //   if(channelData[0].terminalSpecificationList){
      //     list = JSON.parse(channelData[0].terminalSpecificationList)
      //   }
      // }
      if(this.terminalSettingList?.terminalSpecificationList && this.terminalSettingList?.terminalSpecificationList.length > 0){
        list = this.terminalSettingList?.terminalSpecificationList ?? []
      }
      let temp = []
      let alreadySelectedSettings = this.posStaff?.pivot?.settings
      if(alreadySelectedSettings){
        alreadySelectedSettings = JSON.parse(alreadySelectedSettings)
      }
      alreadySelectedSettings =  alreadySelectedSettings?.terminalSpecificationList ?? []

      Object.keys(list).forEach((key) => {
        temp.push({value: alreadySelectedSettings.includes(list[key].name), name: list[key].name, title:list[key].title})
      })
      this.list= temp
    },
  }
}
</script>

<style scoped>
.modal-dialog {
  overflow-y: initial !important
}

.modal-body {
  height: 70vh;
  overflow-y: auto;
}
</style>

